import { debounce } from 'lodash';
import { useMemo, useState } from 'react';

export const useListItemsSearch = () => {
  const [searchValue, setSearchValue] = useState<string>('');

  const handleSearch = useMemo(() => debounce(e => setSearchValue(e.target.value), 200), []);

  return { searchValue, handleSearch };
};
